// @flow
import { compose, applyMiddleware, createStore, combineReducers } from 'redux'
import logger from 'redux-logger'
import { ApolloClient } from 'react-apollo'
import { reducer as ui } from 'modules/ui'
import { reducer as config } from 'modules/config'
import { reducer as user } from 'modules/user'
import { reducer as company } from 'modules/company'
import { reducer as reservationFilter } from 'modules/reservationFilter'

const middlewares = []
let composeEnhancers = compose
if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger)
  /* eslint-disable no-underscore-dangle, no-undef */
  composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose
  /* eslint-enable no-underscore-dangle, no-undef */
}

export default (initialState: Object = {}) => {
  const apolloClient = new ApolloClient()
  const store = createStore(
    combineReducers({
      ui,
      config,
      user,
      company,
      reservationFilter,
      apollo: apolloClient.reducer(),
    }),
    initialState,
    composeEnhancers(
      applyMiddleware(...middlewares, apolloClient.middleware()),
    ),
  )
  return store
}
